import { findIndex, isArray, isObject, isString, reduce, sortBy, toUpper, get } from "lodash";
import query from 'query-string';
import Enums from "./enums/Enums";

export let planTypes = {
  WEBINAR: 'webinar',
  ZOOM_ROOMS: 'zoomroom',
  ZOOM_PHONE: 'pbx',
  ZOOM_PHONE$ADDITIONAL: 'pbx$additional',
  ZOOM_PHONE$ZPA: 'pbx$zpa',
  ZOOM_PHONE$ZPI: 'pbx$zpi',
  ROOM_CONNECTOR: 'rc',
  LARGE_MEETING: 'large_meeting',
  TOLLFREE: 'tollfree',
  TOLLFREE$DID: 'tollfree$did',
  CMR: 'cmr',
  ZOOM_MEETING: 'zoom_meeting',
  API: 'api',
  ZOOM_UNITED: 'zoomunited',
  VIDEO_SDK: 'video_sdk',
  ZOOM_HARDWARE: 'zoom_hardware',
  HIPAA_COMPLIANCE: 'hipaa_compliance',
  PREMIER: 'premier',
  PAID_DEVELOPER: 'paid_developer',
  ZOOM_EVENTS: 'zoom_events',
  WEBINAR_PROMO: 'webinar_promo',
  FREE_TRIAL: 'free_trial',
  QSS: 'quality_streaming_service',
  ZOOM_NODE: 'zoom_node',
  ZOOM_CONTACT_CENTER: 'zcc',
  PHONE_NUMBER: 'pnm',
  ZOOM_IQ: 'zoom_iq',
  MIO: 'mio',
  ZOOM_WHITEBOARD: "whiteboard",
  ZOOM_WHITEBOARD_PLUS: "whiteboard_plus",
  ZOOM_ONE: 'zoomone',
  ZOOM_CHAT: 'zoom_chat',
  ZOOM_ONE_BUNDLE: 'zonebundle',
  TRANSLATION_CAPTIONS: 'translation_captions',
  VIDEO_SDK_TRANSLATION: 'video_sdk_translation',
  ZOOM_ROOM_HARDWARE: 'zr_hardware',
  ZOOM_PHONE_HARDWARE: 'pbx_hardware',
  WORKSPACE_RESERVATION: 'workspace_reservation',
  CMK: 'cmk',
  LDKCMR: 'videosdk_cmr',
  ZOOM_MESH: 'zoom_mesh',
  EVENT_SAAS: 'eventsaas',
  EVENT_SAAS_CORE: 'eventsaascore',
  ADDITIONAL_HOST: 'additional_host',
  ADDITIONAL_CO_EDITOR: 'additional_co_editor',
  ZVA: 'zva',
  Bundle_CREDIT: 'bundleCredit',
  LDKCRC: 'video_sdk_crc',
  API_CSP: 'api_csp',
  ZSU: 'ZSU',
  ZOOM_SCHEDULER: 'zoom_scheduler',
  ZONE_BASIC_PLUS: 'zone_basic_plus',
  ZONE_PPM: 'zone_ppm',
  MASTER_CLASS: 'masterclass',
  ZOOM_CLIPS: "zoom_clips",
  VIDEO_SDK_UC: 'video_sdk_uc',
  ZONE_PRO_PLUS: 'zoneproplus',
  ZOOM_REVENUE_ACCELERATOR: 'zoom_revenue_accelerator',
  ZCM: 'zoom_compliance_manager',
  ZCM_STORAGE: 'zcm_storage',
  CONCURRENCY_MEETING_BASIC: 'concurrency_meeting_basic',
  CONCURRENT_MEETING_PLUS: 'ccm',
  ZOOM_DOCS: "zoom_docs",
  ZONE_EDU_PLUS: 'zone_edu_plus',
  EVENT_SERVICES: 'zoom_event_services',
  VISITOR_MANAGEMENT: 'zvstmgt',
  DRIVE: 'drive',
  CUSTOM_AVATARS: 'custom_avatars'
};

export function isEventSaasOrEventSassCore(planType, withWebinar = true) {
  return planType === planTypes.EVENT_SAAS_CORE || planType === planTypes.EVENT_SAAS || (withWebinar && planType === planTypes.WEBINAR);
}

planTypes = new Enums(planTypes);

export const trackingPlanTypes = {
  WEBINAR: 'zoom webinars',
  ZOOM_ROOMS: 'zoom rooms',
  ZOOM_PHONE: 'zoom phone',
  ZOOM_PHONE$ZPA: 'zoom phone power pack',
  ZOOM_PHONE$ZPI: 'international select add-on',
  ROOM_CONNECTOR: 'rc',
  LARGE_MEETING: 'large meeting',
  CMR: 'cloud recording storage',
  ZOOM_MEETING: 'zoom one',
  API: 'api',
  ZOOM_UNITED: 'zoomunited',
  VIDEO_SDK: 'video_sdk',
  ZOOM_HARDWARE: 'zoom_hardware',
  HIPAA_COMPLIANCE: 'hipaa_compliance',
  PREMIER: 'premier',
  PAID_DEVELOPER: 'paid_developer',
  ZOOM_EVENTS: 'zoom_events',
  WEBINAR_PROMO: 'webinar_promo',
  FREE_TRIAL: 'free_trial',
  QSS: 'quality_streaming_service',
  ZOOM_NODE: 'zoom_node',
  ZOOM_CONTACT_CENTER: 'zcc',
  PHONE_NUMBER: 'pnm',
  ZOOM_IQ: 'zoom_iq',
  MIO: 'mio',
  ZOOM_WHITEBOARD: "zoom whiteboard",
  ZOOM_WHITEBOARD_PLUS: "zoom whiteboard plus",
  ZOOM_ONE: 'zoomone',
  ZOOM_CHAT: 'zoom_chat',
  ZOOM_ONE_BUNDLE: 'zonebundle',
  TRANSLATION: 'translation',
  VIDEO_SDK_TRANSLATION: 'video_sdk_translation',
  ZOOM_ROOM_HARDWARE: 'zr_hardware',
  ZOOM_PHONE_HARDWARE: 'pbx_hardware',
  WORKSPACE_RESERVATION: 'workspace_reservation',
  CMK: 'cmk',
  LDKCMR: 'videosdk_cmr',
  ZOOM_MESH: 'zoom_mesh',
  TRANSLATION_CAPTIONS: 'Translation Captions',
  EVENT_SAAS: 'zoom events',
  EVENT_SAAS_CORE: 'zoom sessions',
  ADDITIONAL_HOST: 'additional_host',
  ADDITIONAL_CO_EDITOR: 'additional_co_editor',
  ZOOM_CLIPS: "Zoom Clips Plus",
  VIDEO_SDK_UC: 'zoom sdk universal credit',
  TOLLFREE: 'Zoom Audio Conferencing',
  TOLLFREE$DID: 'Zoom Audio Conferencing add-ons Dedicated Dial-In Numbers',
  ZONE_PRO_PLUS: 'Zoom Workplace Pro Plus',
  ZONE_BIZ_PLUS: 'Zoom Workplace Business Plus',
  ZOOM_REVENUE_ACCELERATOR: 'Zoom Revenue Accelerator',
  CONCURRENCY_MEETING_BASIC: 'Concurrent Meeting Basic',
  CONCURRENT_MEETING_PLUS: 'Concurrent Meeting Plus',
  ZCM: 'zoom compliance manager powered by theta lake',
  ZCM_STORAGE: 'zoom compliance manager powered by theta lake - additional storage',
  ZOOM_DOCS: 'zoom docs',
  VISITOR_MANAGEMENT: 'visitor management',
  CUSTOM_AVATARS: "custom_avatars"
}
/**
 * Determines whether the given plan includes the "Unlimited Whiteboard" feature.
 *
 * Currently, the following four plans are known to include this feature:
 * 1. Zoom One Business
 * 2. Zoom One Business Plus
 * 3. Zoom Workplace for Education School and Campus
 * 4. Zoom Workplace for Education School and Campus Plus
 * 5. Zoom Meeting Education
 *
 * @param {Object} plan - The plan object to check.
 * @returns {boolean} - Returns true if the plan includes Unlimited Whiteboard, otherwise false.
 */
export function isPlanIncludeUnlimitedWhiteboard(plan) {
  const planCheckList = [
    isZoomOneBusinessPlan,
    isZoomOneBusinessPlusPlan,
    isZoomWorkplaceEduSchoolAndCampusPlan,
    isZoomWorkplaceEduSchoolAndCampusPlusPlan,
    isZoomMeetingEduPlan
  ]
  return planCheckList.some(matchFunction => matchFunction(plan) === true)
}
export function isZoomOneBusinessPlan(plan) {
  return plan && plan.type === planTypes.ZOOM_MEETING && plan.category === BASE_PLAN_SUB_TYPES.BIZ
}
export function isZoomOneBusinessPlusPlan(plan) {
  return plan && plan.type === planTypes.ZOOM_ONE_BUNDLE && plan.sub_type === BASE_PLAN_SUB_TYPES.ZOOM_ONE_BIZ_PLUS
}
export function isZoomWorkplaceEduSchoolAndCampusPlan(plan) {
  return plan && plan.type === planTypes.ZOOM_MEETING && plan.category === BASE_PLAN_SUB_TYPES.ZONE_EDU_SCH_CMP
}
export function isZoomMeetingEduPlan(plan) {
  return plan && plan.type === planTypes.ZOOM_MEETING && plan.category === BASE_PLAN_SUB_TYPES.EDUCATION
}
export function isZoomWorkplaceEduSchoolAndCampusPlusPlan(plan) {
  // the type of `Zoom Workplace for School and Campus Japan` is zoom meeting which is not expected
  return plan && (plan.type === planTypes.ZONE_EDU_PLUS || (plan.type === planTypes.ZOOM_MEETING && /^zoneduschcmpp\w*/i.test(plan.category)))
}
// Please note: the order of billing cycle determines the order in UI

export const BILLING_CYCLE = {
  ONE_TIME: 'one_time',
  ONE_MONTH: 'one_month',
  MONTHLY: 'monthly',
  QUARTERLY: 'quarterly',
  ANNUAL: 'annual',
  TWO_YEARS: 'two_years',
  THREE_YEARS: 'three_years',
  PAY_AS_YOU_GO: 'payAsYouGo',
  PAY_PER_ATTENDEE: 'pay_per_attendee',
};

export const NEXT_CYCLE_KEY_WITH_BILLING_CYCLE_MAP = {
  [BILLING_CYCLE.MONTHLY]: 'nextMonthly',
  [BILLING_CYCLE.ANNUAL]: 'nextAnnual',
  [BILLING_CYCLE.QUARTERLY]: 'nextQuarterly',
  [BILLING_CYCLE.TWO_YEARS]: 'nextTwoYears',
  [BILLING_CYCLE.THREE_YEARS]: 'nextThreeYears',
}

export const TrackingBillingCycleKeys = {
  [BILLING_CYCLE.ONE_TIME]: 'single use',
  [BILLING_CYCLE.ONE_MONTH]: 'one month',
  [BILLING_CYCLE.MONTHLY]: 'monthly',
  [BILLING_CYCLE.QUARTERLY]: 'quarterly',
  [BILLING_CYCLE.ANNUAL]: 'annual',
  [BILLING_CYCLE.TWO_YEARS]: 'two years',
  [BILLING_CYCLE.THREE_YEARS]: 'three years',
  [BILLING_CYCLE.PAY_AS_YOU_GO]: 'pay as you go',
  [BILLING_CYCLE.PAY_PER_ATTENDEE]: 'pay per attendee',
};

export const TrackingBillingCycleUnitKeys = {
  [BILLING_CYCLE.ONE_TIME]: '/use',
  [BILLING_CYCLE.ONE_MONTH]: '/one month',
  [BILLING_CYCLE.MONTHLY]: '/month',
  [BILLING_CYCLE.QUARTERLY]: '/quarter',
  [BILLING_CYCLE.ANNUAL]: '/year',
  [BILLING_CYCLE.TWO_YEARS]: '/two years',
  [BILLING_CYCLE.THREE_YEARS]: '/three years',
  [BILLING_CYCLE.PAY_PER_ATTENDEE]: '/pay per attendee',
};

export const NO_NEED_CHANGE_PRICE_CYCLE = [
  BILLING_CYCLE.ONE_MONTH,
  BILLING_CYCLE.MONTHLY,
  BILLING_CYCLE.ONE_TIME
]

export const ACCOUNT_SALE_CHANNEL = {
  ONLINE: 'Online',
  DIRECT: 'Direct Sales'
}

export function getBillingCycleIndex(billingCycle) {
  return findIndex(Object.keys(BILLING_CYCLE), key => BILLING_CYCLE[key] === billingCycle);
}

export function sortBillingCycle(list) {
  function getBillingCycle(obj) {
    const fieldNameList = ['billingCycle', 'billing_cycle']
    return fieldNameList.reduce((result, key) => {
      if (!result && obj[key]) {
        result = obj[key]
      }
      return result
    }, '')
  }
  return sortBy(list, item => getBillingCycleIndex(getBillingCycle(item)))
}

// Sort by priority.
export const BASE_PLAN_TYPES = [
  planTypes.ZOOM_MEETING,
  planTypes.ZOOM_ONE,
  planTypes.ZONE_BASIC_PLUS,
  planTypes.ZOOM_ONE_BUNDLE,
  planTypes.ZONE_PRO_PLUS,
  planTypes.ZONE_EDU_PLUS,
  planTypes.ZOOM_UNITED,
  planTypes.WORKSPACE_RESERVATION,
  planTypes.VISITOR_MANAGEMENT,
  planTypes.ZOOM_ROOMS,
  planTypes.ZOOM_PHONE,
  planTypes.VIDEO_SDK,
  planTypes.ZOOM_WHITEBOARD,
  planTypes.ZOOM_SCHEDULER,
  planTypes.ZOOM_CLIPS,
  planTypes.ZOOM_DOCS,
];

export const BASE_MEETING_PLAN_TYPES = [
  planTypes.ZOOM_MEETING,
  planTypes.ZOOM_ONE_BUNDLE,
  planTypes.ZOOM_UNITED,
  planTypes.ZONE_PRO_PLUS,
  planTypes.ZONE_EDU_PLUS,
]

export const AUTO_ADD_BASE_PLAN_CODES = [
  'zo_pro_monthly',
  'zo_pro_yearly',
  'zo_pro_quarterly',
  'yearly_c50',
  'monthly_c50',
  'business_yearly_c50',
  'business_monthly_c50',
  'plan_business_quarterly',
  'plan_business_two_years',
  'plan_business_three_years',
  'plan_pro_quarterly',
  'plan_pro_two_years',
  'plan_pro_three_years',
]

export const AUTO_ADD_FREE_TRIAL_BASE_PLAN_CODES = [
  'zo_pro_monthly',
  'zo_pro_yearly',
  'yearly_c50',
  'monthly_c50'
]

export const BASE_PLAN_SUB_TYPES = {
  PRO: 'pro',
  PRO25: 'pro25',
  PRO50: 'pro50',
  PRO_FREE_TRIAL: 'pro_freetrial',
  BIZ: 'biz',
  BIZ_INR: 'biz_inr',
  EDUCATION: 'education',
  ENTERPRISE: 'bundle',
  ENT: 'ent',
  EDU: 'edu',
  EDU_SITE: 'edu_site',
  HC_PRO: 'hc_pro',
  HC_BIZ: 'hc_biz',
  ZOOM_ONE_BIZ_FOR_GOV: 'zone_biz_for_gov',
  ZOOM_ONE_PRO_PLUS: 'zone_proplus',
  ZOOM_ONE_BIZ_PLUS: 'zone_bizplus',
  ZOOM_ONE_ENTERPRISE: 'zone_enterprise',
  ZOOM_ONE_ENTERPRISE_PLUS: 'zone_enterprise_plus',
  WHITEBOARD_BASIC: 'zwbbasic',
  WHITEBOARD_PLUS: 'zwbplus',
  ZOOM_DOCS: 'zdocs',
  ZONE_EDU_PLUS: 'zopschcmp', // customized plancode, identify that it's plus
  ZONE_EDU_SCH_CMP: 'zoneduschcmp', // from backend category
};


export const AUTO_ADD_FREE_TRIAL_BASE_PLAN_CODES_MAPS = new Enums({
  'zo_pro_monthly': BASE_PLAN_SUB_TYPES.PRO,
  'zo_pro_yearly': BASE_PLAN_SUB_TYPES.PRO,
  'yearly_c50': BASE_PLAN_SUB_TYPES.PRO,
  'monthly_c50': BASE_PLAN_SUB_TYPES.PRO,
  'business_yearly_c50': BASE_PLAN_SUB_TYPES.BIZ,
  'business_monthly_c50': BASE_PLAN_SUB_TYPES.BIZ,
  'plan_business_quarterly': BASE_PLAN_SUB_TYPES.BIZ,
  'plan_business_two_years': BASE_PLAN_SUB_TYPES.BIZ,
  'plan_business_three_years': BASE_PLAN_SUB_TYPES.BIZ,
  'plan_pro_quarterly': BASE_PLAN_SUB_TYPES.PRO,
  'plan_pro_two_years': BASE_PLAN_SUB_TYPES.PRO,
  'plan_pro_three_years': BASE_PLAN_SUB_TYPES.PRO
})

// The mapping between planType and parentCategory in plan map
const ADD_ON_PARENT_CATEGORY_TYPES = {
  [planTypes.LARGE_MEETING]: 'LMT',
  [planTypes.ZOOM_WHITEBOARD]: 'ZWB',
  [planTypes.ZOOM_SCHEDULER]: 'ZSCHED',
  [planTypes.TRANSLATION_CAPTIONS]: 'ZTRANSL',
  [planTypes.ZOOM_ROOMS]: 'ZRM',
  [planTypes.ROOM_CONNECTOR]: 'RCN',
  [planTypes.ZOOM_CLIPS]: 'ZCLIPS',
  [planTypes.ZOOM_ONE_BUNDLE]: 'ZONEBIZP',
}

export const BASE_PLAN_PARENT_CATEGORY_TYPES = {
  BIZ_PLUS: 'ZONEBIZP'
}

export const AUDIO_SUB_TYPES = {
  UNLIMITED: 'tollfree_us_ca',
  TOLL_FREE: 'tollfree',
  INDIA_AUDIO: 'tollfree_india',
  DID: 'did',
};

export const zoomOneEnterpriseCategory = new Enums({
  ENT: 'ZOENT',
  ENT_PLUS: 'ZOPENT',
  ENT_SITE: 'ZOENTST',
  ENT_PLUS_SITE: 'ZOPENTST',
  ent_plus: 'zopent'
})

export const SWITCH_CURRENCY = 'switch_currency'

export const usageTypeMap = {
  personal: 'personal',
  business: 'business',
  blank: ''
}
// PRO INCREASE - Pro Yearly & Monthly Plan Codes
export const zoomOneProMonthlyPlanCodes = ['zo_pro_monthly', 'monthly_c50'];
export const zoomOneProYearlyPlanCodes = ['zo_pro_yearly', 'yearly_c50'];

export const NEW_PRO_CATEGORY = 'zo_pro';
export const NEW_PRO_QUARTERLY_CODE = 'zo_pro_quarterly';

export const BIZ_PLAN_CODES_ONLINE_SUPPORTED = ["business_monthly_c50", "business_yearly_c50", "plan_business_quarterly", "plan_business_two_years", "plan_business_three_years"];
export const BIZ_PLUS_PLAN_CODES_ONLINE_SUPPORTED = [
  "zonebizpzvu_monthly",
  "zonebizpzvu_yearly",
  "zonebizpzuu_monthly",
  "zonebizpzuu_yearly",
  "zonebizpzau_monthly",
  "zonebizpzau_yearly",
  "zonebizpzvu_quarterly",
  "zonebizpzvu_two_years",
  "zonebizpzvu_three_years",
  "zonebizpzuu_quarterly",
  "zonebizpzuu_two_years",
  "zonebizpzuu_three_years",
  "zonebizpzau_quarterly",
  "zonebizpzau_two_years",
  "zonebizpzau_three_years",
  "zonebizpzju_monthly",
  "zonebizpzju_yearly",
  "zonebizpzju_quarterly",
  "zonebizpzju_two_years",
  "zonebizpzju_three_years",
  "zobp_pro_global_select_monthly",
  "zobp_pro_global_select_yearly"
];

export const PRO_PLUS_PLAN_CODES_SUPPORTED = [
  'zopp_us_ca_yearly',
  'zopp_us_ca_monthly',
  'zopp_us_ca_quarterly',
  'zopp_us_ca_two_year',
  'zopp_us_ca_three_year',
  'zwpp_us_ca_yearly',
  'zwpp_us_ca_monthly',
  'zwpp_us_ca_quarterly',
  'zwpp_us_ca_two_year',
  'zwpp_us_ca_three_year',
];

export const EDU_SCH_CMP_PLUS_PLAN_CODES_SUPPORTED = [
  'zo_edu_sch_cmp_plus_usca_monthly',
  'zo_edu_sch_cmp_plus_usca_yearly',
  'zo_edu_sch_cmp_plus_ukir_monthly',
  'zo_edu_sch_cmp_plus_ukir_yearly',
  'zo_edu_sch_cmp_plus_aunz_monthly',
  'zo_edu_sch_cmp_plus_aunz_yearly',
  'zo_edu_sch_cmp_plus_jp_monthly',
  'zo_edu_sch_cmp_plus_jp_yearly',
];

export const ZSCHED_PLAN_CODES = ['zsched_monthly', 'zsched_yearly']

export const BUNDLE_PLAN_CODES_ONLINE_SUPPORTED = [
  ...BIZ_PLUS_PLAN_CODES_ONLINE_SUPPORTED,
  ...PRO_PLUS_PLAN_CODES_SUPPORTED,
  ...EDU_SCH_CMP_PLUS_PLAN_CODES_SUPPORTED,
];

export const BUNDLE_WITH_ZP_BASE_PLAN_TYPES = [
  planTypes.ZOOM_ONE_BUNDLE,
  planTypes.ZONE_PRO_PLUS,
  planTypes.ZONE_EDU_PLUS,
];

export const BillingCycleEnum = new Enums({
  [BILLING_CYCLE.ONE_TIME]: 1,
  [BILLING_CYCLE.ONE_MONTH]: 1,
  [BILLING_CYCLE.MONTHLY]: 1,
  [BILLING_CYCLE.QUARTERLY]: 3,
  [BILLING_CYCLE.ANNUAL]: 12,
  [BILLING_CYCLE.TWO_YEARS]: 24,
  [BILLING_CYCLE.THREE_YEARS]: 36,
});

export const DEFAULT_MIN_HOST = 1;
export const DEFAULT_MAX_HOST = 9999;

export const unlockBizAndBizPlusCountByRetention = query.parse(location.search).retention === 'rbu' && /\/billing/.test(document?.referrer || '')
export const unlockBizLicenseCount = get(window, 'campaignFlags.enableNewLicenseLimit.bizAndBizPlus', false) || unlockBizAndBizPlusCountByRetention;
export const unlockBizMaxLicenseCount = get(window, 'campaignFlags.enableNewLicenseLimit.maxBizAndBizPlus', false);

export const ZOOM_MEETING_EDU_SCH_CMP_MIN_LICENSE = 20
export const ZOOM_MEETING_EDU_PLUS_MIN_LICENSE = 20
export const ZOOM_MEETING_EDU_PLUS_MAX_LICENSE = 250

export const ZOOM_MEETING_PRO_MIN_LICENSE = unlockBizLicenseCount ? 1 : 10;
export const ZOOM_MEETING_EDUCATION_MIN_LICENSE = 20;
export const ZOOM_MEETING_EDUCATION_MAX_LICENSE = 149;
export const ZOOM_DOCS_MIN_LICENSE = 1;
export const ZOOM_DOCS_MAX_LICENSE = 99;
export const minBizAndBizPlusLicenseCount = unlockBizLicenseCount ? 1 : 10;
export const maxBizAndBizPlusLicenseCount = unlockBizMaxLicenseCount ? 250 : 99;
export const MAX_SINGLE_USE_WEBINAR_LICENSE_COUNT = 999
//
export const bizAndBizPlusLicenseInterval = `${minBizAndBizPlusLicenseCount}-${maxBizAndBizPlusLicenseCount}`;

/**
 * @TODO
 */
export const limitLicenseWithBaseZoneTypes = [
  planTypes.WEBINAR,
  planTypes.LARGE_MEETING,
  planTypes.EVENT_SAAS,
  planTypes.EVENT_SAAS_CORE,
  planTypes.TOLLFREE$DID,
  planTypes.ZOOM_REVENUE_ACCELERATOR,
  planTypes.CONCURRENCY_MEETING_BASIC,
  planTypes.CONCURRENT_MEETING_PLUS,
  planTypes.ZCM,
  planTypes.CUSTOM_AVATARS
];

/**
 * @TODO
 */
export const limitBillingCycleWithBaseZoneTypes = [
  planTypes.WEBINAR,
  planTypes.LARGE_MEETING,
  planTypes.TRANSLATION_CAPTIONS,
  planTypes.TOLLFREE,
  planTypes.ROOM_CONNECTOR,
  planTypes.ZOOM_ROOMS,
  planTypes.ZOOM_EVENTS,
  planTypes.EVENT_SAAS,
  planTypes.EVENT_SAAS_CORE,
  planTypes.ZOOM_REVENUE_ACCELERATOR,
  planTypes.CONCURRENCY_MEETING_BASIC,
  planTypes.CONCURRENT_MEETING_PLUS,
  planTypes.ZCM,
  planTypes.CUSTOM_AVATARS
];

export const configCapacityTypes = [
  planTypes.WEBINAR,
  planTypes.LARGE_MEETING,
  planTypes.EVENT_SAAS,
  planTypes.EVENT_SAAS_CORE,
];

export const autoAddTypes = [
  planTypes.WEBINAR,
  planTypes.EVENT_SAAS,
  planTypes.EVENT_SAAS_CORE,
];

// zoom events consumption
export const EventSaasConsumptionCategory = 'zeca_yearly';
export const EventSaasConsumptionOverageCategory = 'zeco_overage';

// zoom sessions consumption
export const EventSaasCoreConsumptionCategory = 'zecc_yearly';
export const EventSaasCoreConsumptionOverageCategory = 'zecco_overage';

export const CustomAvatarsPayasYougo = 'custom_avatars_payongo';
export const PayOnGoCategoryList = [CustomAvatarsPayasYougo];

// zoom events & zoom sessions consumption overage category
export const ConsumptionCategoryList = [EventSaasConsumptionOverageCategory, EventSaasCoreConsumptionOverageCategory];

export const MRS_STATUS_TYPE_MAP = {
  CHANGE_NOW: 0,
  CHANGE_FUTURE: 1,
  CHANGE_FUTURE_TICKET: 2,
}

export const ZOOM_EVENTS_SUB_TYPES = {
  EVENT_SAAS: 'eventsaas',
  EVENT_SAAS_CORE: 'eventsaascore',
  EVENT_SAAS_CONSUMPTION: 'eventsaas_consumption',
  EVENT_SAAS_CORE_CONSUMPTION: 'eventsaascore_consumption',
}

export const BAA_COUNTRIES = {
  CANADA: 'CA',
  US: 'US',
  OTHER: 'OTHER',
};

export const AccountType = {
  ACCOUNT_UNKNOWN: 0,
  ACCOUNT_FREE_WITH_CC: 1,		// free with CC
  ACCOUNT_FREE_WITHOUT_CC: 2, 	// free without CC, default account type
  ACCOUNT_PAID: 3, 				// named host <10
  ACCOUNT_ACTIVE_HOST: 4, 		// active host
  ACCOUNT_APP_PARTNER: 5,		// API partner
  ACCOUNT_EDU_HOST: 6,			// edu name host
  ACCOUNT_NAME_HOST_50_UP: 7,	// name host 10+
  ACCOUNT_FREE_TRIAL: 8,			// free trial
  ACCOUNT_VIP: 9,				// VIP
  ACCOUNT_BULK_LICENSE: 10,		// BULK License, other rights like ACCOUNT_PAID
  ACCOUNT_ZOOM_ROOM: 11,		// ZOOM room
  ACCOUNT_LITE_SDK: 12,          // video sdk
  ACCOUNT_ZOOM_PHONE: 18,		// ZOOM Phone
  ACCOUNT_ZOOM_BASIC_MEETING: 20 // ZOOM Basic Meeting
}

export const contactUsPath = '/contactsales';

export const updateTypeMap = {
  downgrade: 0,
  upgrade: 1,
};

export const multiCapacityPlans = [planTypes.LARGE_MEETING, planTypes.WEBINAR]

export const dependMeetingPlanTypeList = [planTypes.ZOOM_MEETING, planTypes.ZONE_PRO_PLUS, planTypes.ZOOM_ONE_BUNDLE, planTypes.ZOOM_UNITED, planTypes.ZOOM_ONE, planTypes.ZOOM_ROOMS, planTypes.ZONE_EDU_PLUS];
export const billingCycleDependBasePlanTypeList = [planTypes.ZOOM_MEETING, planTypes.ZONE_PRO_PLUS, planTypes.ZOOM_ONE_BUNDLE, planTypes.ZOOM_UNITED, planTypes.ZOOM_ONE, planTypes.ZOOM_ROOMS, planTypes.ZONE_EDU_PLUS];
export const licenseDependBasePlanTypeList = [planTypes.ZOOM_MEETING, planTypes.ZONE_PRO_PLUS, planTypes.ZOOM_ONE_BUNDLE, planTypes.ZOOM_UNITED, planTypes.ZOOM_ONE, planTypes.ZOOM_ROOMS, planTypes.ZONE_EDU_PLUS];

/**
 * different plan codes that are exactly the same
 * eg. in price change scenarios, plans are given different codes but meant the same thing
 * {
 *    zo_pro_monthly: 'zo_pro_monthly$monthly_c50',
 *    monthly_c50: 'zo_pro_monthly$monthly_c50',
 * }
 * this is kind of hardcode 😫
 */
export const twinPlancodesMap = [
  ['zo_pro_monthly', 'monthly_c50'],
].reduce((acc, x) => {
  x.forEach(plancode => {
    acc[plancode] = x.join('$');
  });
  return acc;
}, {});

export const companySetupProductTypeMap = {
  pbx: 'phone',
  pro: 'zoom_one_pro',
  biz: 'zoom_one_business',
  biz_plus: 'zoom_one_business_plus',
  pro_plus: 'zoom_one_pro_plus',
  edu_sch_cmp_plus: '', // TODO ??
};

export const EDIT_FLOW_TRACKING_TYPE = {
  NOT_ABLE_TO: "notAbleTo",
  HAS_CUSTOMER_PRICING: "hasCustomerPricing",
  KEEP_ADDON: "keepAddon"
}

export const A_LINK_TEXT_CONTENT = {
  FORM: "form",
  RETURN_PLAN_MANAGEMENT: "Return to Plan Management",
}

export const A_LINK_TAG_NAME = "A";

export const ConfigPageSchema = new Enums({
  SINGLE: 'single',
  MULTIPLE: 'multiple',
});

export const bizTypes = ['biz', 'mfg', 'adv', 'ps', 'fin', 'edu', 'med', 'util', 'telcomm', 'edu_high', 'sci_tech_inst', 'gov', 'bp', 'cnstr', 'ent', 'lgl', 'hpy', 'np', 'tech', 'trans', 're', 'other'];

export const CURRENCY_INR = 'INR';

export const CURRENCY_USD = 'USD';

export const COUNTRY_CODE_INDIA = 'IN';

export const COUNTRY_CODE_US = 'US';

export const CURRENCY_KRW = 'KRW';

export const CURRENCY_VND = 'VND';

export const CURRENCY_PHP = 'PHP';

export const ZOOM_SASS_ADDITIONAL_CATEGORIES = [planTypes.ADDITIONAL_HOST, planTypes.ADDITIONAL_CO_EDITOR];

export const ADDON_ACCORDION_THRESHOLD = 3;

export const AUDIO_RATE_TYPES = {
  TOLL_FREE: 'tollFreeCountrys',
  CALL_OUT: 'calloutCountrys',
  PREMIUM: 'tollFreePremiumCountrys',
};

export const AUDIO_BUNDLE_TYPE = {
  NONE: 'none',
  US_CA: 'us_ca',
  IN: 'IN',
}

export const ADDON_GROUP = {
  JOINT_SALES: 'jointsales',
  BIZ_PLUS: 'bizplus',
}

export const PLAN_PARENT_CATEGORY_TYPES = reduce([
  {
    planType: planTypes.ZOOM_MEETING,
    codes: [BASE_PLAN_SUB_TYPES.PRO, BASE_PLAN_SUB_TYPES.BIZ, BASE_PLAN_SUB_TYPES.EDU]
  },
  planTypes.LARGE_MEETING,
  planTypes.WEBINAR,
  planTypes.ZOOM_WHITEBOARD,
  planTypes.ZOOM_SCHEDULER,
  planTypes.TRANSLATION_CAPTIONS,
  planTypes.ZOOM_ROOMS,
  planTypes.ROOM_CONNECTOR,
  planTypes.ZOOM_CLIPS,
  planTypes.ZOOM_ONE_BUNDLE
], (result, item) => {
  if (isString(item)) {
    if (ADD_ON_PARENT_CATEGORY_TYPES[item]) {
      result[item] = toUpper(ADD_ON_PARENT_CATEGORY_TYPES[item]);
    }
  } else if (isObject(item)) {
    const {planType, codes} = item;
    if (isString(codes)) {
      result[planType] = codes;
    } else if (isArray(codes)) {
      result[planType] = codes.map((code) => toUpper(code));
    } else {
      if (ADD_ON_PARENT_CATEGORY_TYPES[planType]) {
        result[planType] = ADD_ON_PARENT_CATEGORY_TYPES[planType];
      }
    }
  }

  return result;
}, {})

export function getPlanTypeFromParentCategory(parentCategory) {
  if (isString(parentCategory)) {
    const matchedPlanType = Object.keys(PLAN_PARENT_CATEGORY_TYPES).find((planType) => {
      const parentCategoryMatchItem = PLAN_PARENT_CATEGORY_TYPES[planType];
      if (isString(parentCategoryMatchItem)) {
        return toUpper(parentCategoryMatchItem) === toUpper(parentCategory);
      } else if (isArray(parentCategoryMatchItem)) {
        return parentCategoryMatchItem.includes(toUpper(parentCategory));
      }
    })
    return matchedPlanType || '';
  }
  return '';
}

export const APM_STRIPE_OPTIONS = ['sofort', 'ideal', 'customer_balance', 'us_bank_account', 'klarna', 'p24']
export const P2P_ALLOWED_APM_STRIPE_OPTIONS = ['ideal', 'customer_balance', 'us_bank_account', 'p24']
export const UPDATE_PAYMENT_MAX_ATTEMPTS_EXCEEDED_ERROR_CODE = 11022
export const APM_PAYMENT_METHODS = { FURIKOMI: 'customer_balance', ALTERNATIVE_CREDIT_CARD: 'card', KLARNA: 'klarna', P24: 'p24' };
export const MULTI_UPDATE_PLAN_TYPES = [
  planTypes.LARGE_MEETING,
  planTypes.WEBINAR,
  planTypes.EVENT_SAAS,
  planTypes.EVENT_SAAS_CORE,
  planTypes.CONCURRENCY_MEETING_BASIC,
  planTypes.CONCURRENT_MEETING_PLUS
];

export const UNSUPPORTED_APM_PLAN_ERROR_CODE = 11003

export const INR_SESSION_EMAIL_IS_INCORRECT_ERROR_CODE = 1020;

export const INR_DELAYED_PROVISIONING_INITIATED_ERROR_CODE = 1021;

export const INR_HAVE_PENDING_INVOICE_ERROR_CODE = 1022;

export const DEFAULT_FREE_TRIAL_DAYS = 30; // FREE TRIAL - default free trial days

export const STAND_ALONE_PLAN_TYPES = [planTypes.ZOOM_PHONE, planTypes.ZOOM_ROOMS, planTypes.ZOOM_WHITEBOARD, planTypes.ZOOM_WHITEBOARD_PLUS, planTypes.ZOOM_CLIPS, planTypes.ZOOM_SCHEDULER, planTypes.ZOOM_DOCS];
export const SMB_ALWAYS_FETCH_NONSTANDARD_TYPES = [planTypes.CONCURRENCY_MEETING_BASIC, planTypes.CONCURRENT_MEETING_PLUS];

export const PlanDisabledStatusEnum = new Enums({
  CANCELED: 'cancelled',
  DECREASE_REQUEST: 'has_decrease_request',
  PENDING_PLAN: 'has_same_pending_plan',
  DOWNGRADE_REQUEST: 'has_downgrade_request',
  SHOULD_DISABLED: 'should_disabled'
})

export const PBX_CATEGORYS = {
  ZVP: 'ZVP',
};

export const EVENT_SAAS_ADDITIONAL_HOST = 'eventsaas-additionalhost';
export const EVENT_SAAS_CORE_ADDITIONAL_HOST = 'eventsaascore-additionalhost';
export const EVENT_SAAS_ADDITIONAL_CO_EDITOR = 'eventsaas-additionalcoeditor';
export const EVENT_SAAS_CORE_ADDITIONAL_CO_EDITOR = 'eventsaascore-additionalcoeditor';

export const ZOOM_ONE_PRO_PLUS_MAX_LICENSE = 99;

export const ZONE_PRO_PLUS_PARENT_CATEGORY = 'ZONEPROP';
export const ZONE_BIZ_PLUS_PARENT_CATEGORY = 'ZONEBIZP';

export const ENUM_UPGRADE_TYPE = {
  // FREE TRIAL
  ONLINE_FREE_TRIAL_UPGRADE: 2, // backend enum value, could be more in future
  ONLINE_FREE_TRIAL_UPGRADE_WITH_ADD_PLAN: 4
}

export const PLAN_UPGRADE_BIZ_TYPE = {
  OP_FREETRIAL_PLAN_UPGRADE: 1, // OP free trial plan upgrade
  ONLINE_FREE_TRIAL_PLAN_UPGRADE: 2, // Online free trial plan upgrade
  PAY_BY_CHECK_PLAN_UPGRADE: 3, // Pay by check plan upgrade
  ONLINE_FREETRIAL_PLAN_UPGRADE_AND_ADD_PLAN: 4, // Online free trial plan upgrade and add other plan
  PLAN_PURCHASE: 5, // online free trial account purchase new plan

}

export const ZOOM_SASS_ADDONS = [planTypes.ADDITIONAL_CO_EDITOR, planTypes.ADDITIONAL_HOST];

export const ABANDON_CART_EMAIL_COOKIE_KEY = 'scheduledEmailId';

export const SPECIFIC_REGIONS = ['kr'];

const proPackageUpdatePhase1 = get(window.newBillingConfig, 'proPackageUpdatePhase1', false);
export const CMR_STORAGE_FOR_MEETING_PLAN = proPackageUpdatePhase1
  ? {
    [BASE_PLAN_SUB_TYPES.PRO]: 10,
    [BASE_PLAN_SUB_TYPES.ZOOM_ONE_PRO_PLUS]: 5,
    [BASE_PLAN_SUB_TYPES.BIZ]: 10,
    [BASE_PLAN_SUB_TYPES.ZOOM_ONE_BIZ_PLUS]: 15,
    [BASE_PLAN_SUB_TYPES.EDUCATION]: 0.5,
    [BASE_PLAN_SUB_TYPES.ZONE_EDU_SCH_CMP]: 5,
    [BASE_PLAN_SUB_TYPES.ZONE_EDU_PLUS]: 10,
  }
  : {
    [BASE_PLAN_SUB_TYPES.PRO]: 5,
    [BASE_PLAN_SUB_TYPES.ZOOM_ONE_PRO_PLUS]: 5,
    [BASE_PLAN_SUB_TYPES.BIZ]: 5,
    [BASE_PLAN_SUB_TYPES.ZOOM_ONE_BIZ_PLUS]: 10,
    [BASE_PLAN_SUB_TYPES.EDUCATION]: 0.5,
    [BASE_PLAN_SUB_TYPES.ZONE_EDU_SCH_CMP]: 5,
    [BASE_PLAN_SUB_TYPES.ZONE_EDU_PLUS]: 10,
  }

export const getMeetingDefaultCMRStorage = (plan = {}) => {
  const { sub_type, category } = plan
  return CMR_STORAGE_FOR_MEETING_PLAN[sub_type] || CMR_STORAGE_FOR_MEETING_PLAN[category];
}

export const ZOOM_EDUCATION_INDIVIDUAL_PLAN_TYPES = [
  planTypes.WEBINAR,
  planTypes.ZOOM_PHONE,
  planTypes.ZOOM_ROOMS
]

export const ZOOM_EDUCATION_OPTIONAL_PLAN_TYPES = [
  planTypes.LARGE_MEETING,
  planTypes.TOLLFREE,
  planTypes.CMR
]

export const INDUSTRIES = {
  HEALTHCARE: 'healthcare',
}

export const PLAN_CATEGORY_PLAN_CODES_GROUP = {
  [BASE_PLAN_SUB_TYPES.PRO]: [...zoomOneProMonthlyPlanCodes, ...zoomOneProYearlyPlanCodes],
  [BASE_PLAN_SUB_TYPES.BIZ]: BIZ_PLAN_CODES_ONLINE_SUPPORTED,
}

export const OPC_CONSTANT_PATH = {
  basic2pro: '/opc/buy?plan=pro&subPlan=allSubPlan&type=basic2pro',
  basic2biz: '/opc/buy?plan=biz&subPlan=allSubPlan&type=basic2pro'
}

export const WEBINAR_CATEGORY = {
  webinar100: 'webinar100',
  webinar500: 'webinar500',
  webinar1000: 'webinar1000',
  webinar3000: 'webinar3000',
  webinar5000: 'webinar5000',
  webinar10000: 'webinar10000',
  webinar20000: 'webinar20000',
  webinar30000: 'webinar30000',
  webinar50000: 'webinar50000',
  webinar100000: 'webinar100000',
  webinar250000: 'webinar250000',
  webinar500000: 'webinar500000',
  webinar1000000: 'webinar1000000',
};

export const WEBINAR_ONE_TIME_CATEGORY = [
  WEBINAR_CATEGORY.webinar20000,
  WEBINAR_CATEGORY.webinar30000,
  WEBINAR_CATEGORY.webinar50000,
  WEBINAR_CATEGORY.webinar100000,
  WEBINAR_CATEGORY.webinar250000,
  WEBINAR_CATEGORY.webinar500000,
  WEBINAR_CATEGORY.webinar1000000,
];

export const WEBINAR_CAPACITY_MAP = {
  [WEBINAR_CATEGORY.webinar100]: 100,
  [WEBINAR_CATEGORY.webinar500]: 500,
  [WEBINAR_CATEGORY.webinar1000]: 1000,
  [WEBINAR_CATEGORY.webinar3000]: 3000,
  [WEBINAR_CATEGORY.webinar5000]: 5000,
  [WEBINAR_CATEGORY.webinar10000]: 10000,
  [WEBINAR_CATEGORY.webinar20000]: 20000,
  [WEBINAR_CATEGORY.webinar30000]: 30000,
  [WEBINAR_CATEGORY.webinar50000]: 50000,
  [WEBINAR_CATEGORY.webinar100000]: 100000,
  [WEBINAR_CATEGORY.webinar250000]: 250000,
  [WEBINAR_CATEGORY.webinar500000]: 500000,
  [WEBINAR_CATEGORY.webinar1000000]: 1000000,
};

export const WEBINAR_NON_ONE_TIME_CAPACITY = [
  WEBINAR_CAPACITY_MAP.webinar100,
  WEBINAR_CAPACITY_MAP.webinar500,
  WEBINAR_CAPACITY_MAP.webinar1000,
  WEBINAR_CAPACITY_MAP.webinar3000,
  WEBINAR_CAPACITY_MAP.webinar5000,
  WEBINAR_CAPACITY_MAP.webinar10000,
];

export const WEBINAR_ONE_TIME_CAPACITY = [
  WEBINAR_CAPACITY_MAP.webinar20000,
  WEBINAR_CAPACITY_MAP.webinar30000,
  WEBINAR_CAPACITY_MAP.webinar50000,
  WEBINAR_CAPACITY_MAP.webinar100000,
  WEBINAR_CAPACITY_MAP.webinar250000,
  WEBINAR_CAPACITY_MAP.webinar500000,
  WEBINAR_CAPACITY_MAP.webinar1000000,
];

export const SUBSCRIPTION_TYPE = {
  one_time: 'one_time',
  recurring: 'recurring',
  pay_per_attendee: 'pay_per_attendee',
  one_month: 'one_month',
  recurring_and_one_month: 'recurring_and_one_month'
};

export const VIEWS = {
  CONFIG: 'config', // config page
  COMPOUND: 'compound', // config page with payment module
  MODAL: 'modal', // config page in modal style
};

export const PageTypes = {
  normal: 'normal',
  modal: 'modal',
}

export const SERVICE_CATEGORY_CODE = {
  wbnsu: 'wbnsu', // webinar single-use
  esmwbn: 'esmwbn', // webinar single-use pso
};

export const JAPANESE_YEN = 'JPY'

export const DEFAULT_COMPANY_NAME = 'Zoom Video Communications'

export const CAMPAIGN_CODES = {
  SCHEDULER: 'zoom_scheduler_campaign'
}

export const ALLOW_MIXED_BUY_FREE_TRIAL_PLANS = [planTypes.ZOOM_SCHEDULER]

export const ALLOWED_PAID_PLAN_IN_BUYTRIAL = [planTypes.ZOOM_MEETING]

export const ENUM_ZUORA_COUPON_TYPE = {
  MLM_NONE_DISTRIBUTION: 1,
  MLM_DISTRIBUTION: 2,
  MARKETING: 3,
  CANCELLATION: 4,
  RENEW: 5
}

export const APP_NAME = 'fe-billing-one-page'


export const ONLINE_FREE_TRIAL_PLANS = [
  planTypes.ZOOM_SCHEDULER,
  planTypes.EVENT_SAAS_CORE,
  planTypes.ZOOM_MEETING,
  planTypes.WEBINAR,
];

export const BADGE_ID_MAPPER = get(window, '__ZM_BILLING_SHARED.constants.AUTO_EXPIRE_BADGE.BADGE_ID_MAPPER', {
  TASKS: 'tasks',
  CUSTOM_AVATAR: 'custom-avatar',
  WORKFLOW_AUTOMATION: 'workflow-automation',
  DRIVE: 'drive',
});

export const BUSINESS_TYPE_QUERY_KEY = '_businessType'; // only for billing business logic type
export const PARTIAL_SUCCESS_QUERY_BUSINESS_ENUM = {
  openInvoicePayFail: '1', // [open-invoice] when the customer have open invoice and then create a new subscription, the subscription have pay successful, but the open invoice pay fail case
};

export const URL_PAGE_TYPE_KEY = "pageType";
